import { useTheme, type ContrastPreference, type ThemePreference } from '@hgc/ui';
import type { JSX } from 'react';

const THEME_LABELS: ReadonlyArray<readonly [ThemePreference, string]> = [
  ['light', '浅色'],
  ['dark', '深色'],
  ['system', '跟随系统'],
];

const CONTRAST_LABELS: Record<ContrastPreference, string> = {
  normal: '标准对比度',
  high: '高对比度',
};

/**
 * 外观控制。
 *
 * 放在标题栏而不是埋在设置页：GCS 的作业环境差异极大（机库、正午户外、夜间值守），
 * 切换外观必须是**零跳转**的动作。
 */
export function ThemeControls(): JSX.Element {
  const { preference, setPreference, contrast, setContrast } = useTheme();

  return (
    <div className="flex items-center gap-3">
      <div
        className="flex items-center gap-0.5 rounded-control border border-line bg-surface-2 p-0.5"
        role="group"
        aria-label="外观"
      >
        {THEME_LABELS.map(([value, label]) => (
          <button
            key={value}
            type="button"
            aria-pressed={preference === value}
            onClick={() => setPreference(value)}
            className="rounded-[calc(var(--radius-control)-2px)] px-2 py-0.5 text-xs text-fg-muted transition-colors aria-pressed:bg-surface-1 aria-pressed:text-fg aria-pressed:shadow-[0_1px_2px_rgb(0_0_0/0.08)]"
          >
            {label}
          </button>
        ))}
      </div>

      <button
        type="button"
        aria-pressed={contrast === 'high'}
        title={CONTRAST_LABELS.high}
        onClick={() => setContrast(contrast === 'high' ? 'normal' : 'high')}
        className="rounded-control border border-line px-2 py-1 text-xs text-fg-muted transition-colors hover:text-fg aria-pressed:border-accent aria-pressed:bg-accent-soft aria-pressed:text-accent"
      >
        高对比度
      </button>
    </div>
  );
}
